import { render, staticRenderFns } from "./TrBookIndex.vue?vue&type=template&id=850912fc&scoped=true&"
import script from "./TrBookIndex.vue?vue&type=script&lang=js&"
export * from "./TrBookIndex.vue?vue&type=script&lang=js&"
import style0 from "./TrBookIndex.vue?vue&type=style&index=0&id=850912fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850912fc",
  null
  
)

export default component.exports